import type { Reference, ServiceRequest } from '@medplum/fhirtypes'
import { Order } from '@seen/core/models/orders/Order'
import { Button } from '@seen/ui'
import { IconX } from '@tabler/icons-react'
import type { JSX } from 'react'
import { OrderMention } from '#src/components/OrderMention.tsx'
import { useRead } from '#src/hooks/useRead.ts'

export function OrderMentionRemovable({
  order,
  onRemove,
}: {
  order: Reference<ServiceRequest>
  onRemove: () => void
}): JSX.Element {
  const { data: _order } = useRead(Order, order)
  return (
    <div className="flex min-w-0 items-center">
      <OrderMention
        order={order}
        hideParticipant
        className="inline-block max-w-full truncate align-middle text-sm"
      />
      <Button variant="ghost" onClick={onRemove} size="xs">
        <IconX size={12} className="text-muted-foreground" />
      </Button>
    </div>
  )
}
